"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const typography_module_scss_1 = __importDefault(require("@campgladiator/cgui-core.atoms.typography/typography.module.scss"));
const input_module_scss_1 = __importDefault(require("./input.module.scss"));
const cgui_core_atoms_avatar_1 = require("@campgladiator/cgui-core.atoms.avatar");
const setInputTextSizeOnInputFieldSize = (inputSize) => (inputSize === "small" ? "xsmall" : "small");
const InputField = react_1.default.forwardRef((_a, ref) => {
    var { initialValue, className, inputSize = "default", invalid = false, disabled = false, onInputChange } = _a, props = __rest(_a, ["initialValue", "className", "inputSize", "invalid", "disabled", "onInputChange"]);
    const [value, setValue] = (0, react_1.useState)(initialValue);
    return (react_1.default.createElement("input", Object.assign({ className: (0, classnames_1.default)(input_module_scss_1.default.input, typography_module_scss_1.default.paragraph, className), "data-invalid": invalid, "data-input-size": inputSize, "data-size": setInputTextSizeOnInputFieldSize(inputSize), value: value, onChange: (e) => {
            setValue(e.target.value);
            onInputChange && onInputChange(e.target.value);
        }, disabled: disabled, ref: ref }, props)));
});
const Input = react_1.default.forwardRef((_a, ref) => {
    var { className, inputSize = "default", icon, avatar, onIconClick = () => { } } = _a, props = __rest(_a, ["className", "inputSize", "icon", "avatar", "onIconClick"]);
    const commonIconProps = () => {
        if (!!icon) {
            if (!!icon) {
                return {
                    className: input_module_scss_1.default.icon,
                    name: icon.name,
                    ["data-input-size"]: inputSize,
                    onClick: onIconClick,
                };
            }
        }
    };
    return (react_1.default.createElement("div", { className: input_module_scss_1.default.inputWrapper },
        avatar && (react_1.default.createElement(cgui_core_atoms_avatar_1.Avatar, Object.assign({}, avatar, { size: inputSize === "default" ? "30px" : "20px", className: input_module_scss_1.default.avatar }))),
        react_1.default.createElement(InputField, Object.assign({ className: (0, classnames_1.default)({ [input_module_scss_1.default.iconIncluded]: icon, [input_module_scss_1.default.avatarIncluded]: avatar }, className), ref: ref, inputSize: inputSize }, props)),
        (icon === null || icon === void 0 ? void 0 : icon.type) === "solid" && react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Solid, Object.assign({}, commonIconProps())),
        (icon === null || icon === void 0 ? void 0 : icon.type) === "line" && react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, Object.assign({}, commonIconProps())),
        (icon === null || icon === void 0 ? void 0 : icon.type) === "monochrome" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Monochrome, Object.assign({}, commonIconProps(), { emphasis: icon.emphasis })))));
});
exports.default = Input;
//# sourceMappingURL=input.js.map